import React, { Fragment, useState, useEffect, useRef } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useTranslation } from 'react-i18next';
import travelimg from './tr.png';
import { Container, Form, Row, Col, Card, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import SignatureCanvas from 'react-signature-canvas';
const { config } = require('../src/api/api');

function Outboundquestion() {
  const base_url = config.baseURL;
  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';

  const { t } = useTranslation();

  const [dhofarData, setDhofarData] = useState(false);
  const [isSignatureEmpty, setIsSignatureEmpty] = useState(true);
  useEffect(() => {
    const storedDhofarString = Cookies.get('dhofarDataoutbound');
    if (storedDhofarString !== undefined) {
      const storedDhofar = JSON.parse(storedDhofarString);
      setDhofarData(storedDhofar);
    }
    else {
      // alert("token expired");
      // window.location.href='/';
    }
  }, []);

  const [appDataf, setAppDataf] = useState(false);
  useEffect(() => {
    const storedAppStringf = sessionStorage.getItem('outboundappdataf');
    if (storedAppStringf) {
      const storedAppf = JSON.parse(storedAppStringf);
      setAppDataf(storedAppf);
    }
  }, []);

  const [appData, setAppData] = useState(false);
  useEffect(() => {
    const storedAppString = sessionStorage.getItem('outboundapplicationData');
    if (storedAppString) {
      const storedApp = JSON.parse(storedAppString);
      setAppData(storedApp);
    }
  }, []);

  const postData = { token: dhofarData };


  const [vendorKey, setVendorKey] = useState('');
  const [userData, setUserData] = useState();

  useEffect(() => {
    const storedUserString = Cookies.get('userData'); //sessionStorage.getItem('userData')
    if (storedUserString != undefined) {
      const storedUser = JSON.parse(storedUserString);
      setUserData(storedUser);
    } else {
      // alert("token expired");
      // window.location.href = '/';
    }
  }, []);

  useEffect(() => {

    const postvData = { organization_name: "Superjet" };

    if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {


      fetch(base_url+'/create_organization', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postvData),
      })
        .then(response => response.json())
        .then(data => {
          setVendorKey(data.result[0].vendor_key);
        })
        .catch(error => {
          console.error('Error posting data:', error);
        });


    }
  }, [vendorKey]); // Dependency array


  const [ques, setQues] = useState(null);

  if (vendorKey !== '' && ques === null) {

    fetch(base_url+'/get_outbound_questions', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${vendorKey}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(postData),
    })
      .then(response => response.json())
      .then(data => {
        // debugger
        setQues(data.result.data);
      })
      .catch(error => {
        console.error('Error posting data:', error);
      });

  }


  const [selectedqOption1, setSelectedqOption1] = useState(null);
  const [selectedqOptionid1, setSelectedqOptionid1] = useState(false);

  const [selectedqOption2, setSelectedqOption2] = useState(null);
  const [selectedqOptionid2, setSelectedqOptionid2] = useState(false);

  const handleqOptionChange = (event, extraValue) => {
debugger
    if (extraValue === 0) {
      setSelectedqOption1(event.target.value);
      setSelectedqOptionid1(event.target.id);
    }
    else if (extraValue === 1) {
      setSelectedqOption2(event.target.value);
      setSelectedqOptionid2(event.target.id);
    }

  };

  const [loading, setLoading] = useState(false);

  const signatureRef = useRef();

  const handleSubmit = async () => {
debugger 
    if (selectedqOption1 !== selectedqOptionid1) {
      if (selectedqOption1 == null) {
        alert(`Select answer to continue`);
      }
      else {
        alert(`Please select the Answer ${selectedqOptionid1} in question 1`);
      }

      return;
    }
    else if (selectedqOption2 !== selectedqOptionid2) {
      if (selectedqOption2 == null) {
        alert(`Select answer to continue`);
      }
      else {
        alert(`Please select the Answer ${selectedqOptionid2} in question 2`);
      }
      return;
    }else if (signatureRef.current.isEmpty()) {
      alert('Please put signature');
    } else if (!isChecked1) {

      alert('Please ensure the declare');
    } else if (!isChecked2) {

      alert('Please ensure the declare');
    }else if (!isChecked3) {

      alert('Please ensure the declare');
    }
    else {
      debugger
      setLoading(true);
      const signature = signatureRef.current.toDataURL();

      const questionData={
        isChecked1:isChecked1,
        isChecked2:isChecked2,
        isChecked3:isChecked3,
        selectedqOption1:selectedqOption1,
        selectedqOption2:selectedqOption2,
        selectedqOptionid1:selectedqOptionid1,
        selectedqOptionid2:selectedqOptionid2
      }
       sessionStorage.setItem("outboundQuestionData",JSON.stringify(questionData));
       sessionStorage.setItem("outboundSignature",signature);


      const noActualCircumstances = selectedqOption1;

      const inGoodHealth = selectedqOption2;

      const combinedData = { ...appData, ...appDataf, noActualCircumstances, inGoodHealth, signature };
      var pdata = null;
      var policy_url = '';
      // if (userData != null && userData != undefined && userData.agency_name != undefined) {
      //   policy_url = base_url+'/add_outbound_policy_agency_user';
      //   pdata = [{ token: dhofarData }, { agent_token: userData.access_token }, combinedData];
      // } 
      if(userData && userData.first_name && userData.last_name){ 
        policy_url = base_url+'/add_outbound_policy_user';
        pdata = [{ token: dhofarData },{access_token:userData.access_token}, combinedData];
      }
      else{
         policy_url = base_url+'/add_outbound_policy';
        pdata = [{ token: dhofarData }, combinedData];
      }

      // debugger

      // const pdata = [{ token: dhofarData }, combinedData];
      debugger
      await fetch(policy_url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${vendorKey}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(pdata),
      })
        .then(response => response.json())
        .then(data => {
          sessionStorage.setItem("outboundpolicyNumber", JSON.stringify(data.result.policy_number));
          window.location.href = `/outbound-summary`;
        })
        .catch(error => {
          console.error('Error posting data:', error);
        });

    }

  };


  //     const [isChecked, setIsChecked] = useState(false);
  //     const [isChecked1, setIsChecked1] = useState(false);
  //     const [isChecked2, setIsChecked2] = useState(false);

  //     const handleCheckboxChange = (event) => {
  //         setIsChecked(event.target.checked);
  //     };
  //     const handleCheckboxChange1 = (event) => {
  //       debugger
  //       setIsChecked1(event.target.checked);
  //   };
  //   const handleCheckboxChange2 = (event) => {
  //     setIsChecked2(event.target.checked);
  // };

  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [isChecked3, setIsChecked3] = useState(false);

  // Function to check if all checkboxes are checked
  const allChecked = isChecked1 && isChecked2 && isChecked3;

  const clearSignature = () => {
    signatureRef.current.clear();
    sessionStorage.removeItem("outboundSignature");
    setIsSignatureEmpty(true); // Disable button after clearing
  };
  const handleSignature = () => {
    if (!signatureRef.current.isEmpty()) {
      setIsSignatureEmpty(false); // Enable button when signature is drawn
    }
  };

  useEffect(()=>{
      const questionSession =  sessionStorage.getItem("outboundQuestionData");
    
      if(questionSession ){
        const parseQuestion = JSON.parse(questionSession);
        if(parseQuestion ){


          setIsChecked1(parseQuestion?.isChecked1);
          setIsChecked2(parseQuestion?.isChecked2);
          setIsChecked3(parseQuestion?.isChecked3);
          setSelectedqOption1(parseQuestion.selectedqOption1);
          setSelectedqOption2(parseQuestion.selectedqOption2);
          setSelectedqOptionid1(parseQuestion.selectedqOptionid1);
          setSelectedqOptionid2(parseQuestion.selectedqOptionid2);
        }
      }
  },[])

  return (
    <Fragment>

      <div className="header_section1">

        <Navbar />


        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{t('Outbound')} {t('Plan')}</h3>
          </div>
        </div>


      </div>


      <div className="features_section my-1">
        <div className="container">

          <div className="row">

            <Col md={3}></Col>

            <Col md={6} className="myforms my-5">



              <h4 className="px-0 py-2">{t("Question")}</h4>

              {/* <form onSubmit={handleSubmit}> */}

              {ques && ques.map((mopt, index) =>

                <div style={{ direction: 'ltr' }}>

                  <p>{index+1}.{mopt.English}</p>

                  <Row>
                    <Col md={4}>
                      <div class="align-items-center travel-selection-option">
                        {(lnstr === 'en') ? 'YES' : 'نعم\n'}
                        <input type="radio" name={`questionans${index}`} id={mopt.accepted_answer} value="Yes" onChange={(e) => handleqOptionChange(e, index)} 
                        checked={index==0
                          ? selectedqOption1==="Yes":selectedqOption2==="Yes" } className="d-inline-block option-circle ml-auto" />
                      </div>
                    </Col>

                    <Col md={4}>
                      <div class="align-items-center travel-selection-option">
                        {(lnstr === 'en') ? 'NO' : 'لا'}
                        <input type="radio" name={`questionans${index}`} id={mopt.accepted_answer} value="No" onChange={(e) => handleqOptionChange(e, index)} 
                         checked={index==0
                          ? selectedqOption1==="No":selectedqOption2==="No" } 
                          className="d-inline-block option-circle ml-auto" />
                      </div>
                    </Col>
                  </Row><br />

                </div>

              )}

              <Row>

                <Col md={12}>

                  {lnstr=="en"? <b>Please put your signature here</b>:<b>من فضلك وقع هنا</b>}
                  <br />

                 <SignatureCanvas
                                ref={(ref)=>{
                                  signatureRef.current=ref;
                                  const  storedSignature=sessionStorage.getItem("outboundSignature");
                                  if(storedSignature && ref){
                                    // ref.clear();
                                    ref.fromDataURL(storedSignature);
                                    setIsSignatureEmpty(false);
                                  }
                
                                }}
                                penColor="black"
                                canvasProps={{ width: 340, height: 200, className: 'sigCanvas' }}
                                style={{ border: '1px solid #ccc', backgroundColor: 'white' }} // Ensure background is white
                                onEnd={handleSignature} // Detect when drawing ends
                              />
                  <div>
                    <button type="button"
                      style={{ backgroundColor: !isSignatureEmpty ? '#61dafb' : 'grey', borderColor: '#61dafb' }}
                      className="rounded-pill text-white my-3 py-1 " onClick={async () => {
                        clearSignature();
                      }}
                      disabled={isSignatureEmpty}
                    >
                     {t("Clear Signature")}
                    </button>
                  </div>

                </Col>

              </Row>


              <Row>

                <Col md={12} style={{ direction: 'ltr' }}>

                  <p><input type="checkbox" checked={isChecked1}
                    onChange={() => setIsChecked1(prev => !prev)} name="note" />{lnstr=="en"? <span>I/We agree that this application shall form the basis of a contract between me/us and Dhofar Insurance Co. (SAOG).</span>:<span>أوافق/نوافق على أن هذا الطلب سيشكل أساس العقد بيني/بيننا وبين شركة ظفار للتأمين (ش.م.ع.م).</span>} <br /><br />

                    <input type="checkbox" checked={isChecked2}
                      onChange={() => setIsChecked2(prev => !prev)} name="note" /> {lnstr=="en"? <span>I/We agree to abide by the terms and conditions set out in the policy.</span>:<span>أوافق/نوافق على الالتزام بالشروط والأحكام المنصوص عليها في السياسة.</span>}  <br /><br />
                    <input type="checkbox" checked={isChecked3}
                      onChange={() => setIsChecked3(prev => !prev)} name="note" />{lnstr=="en"? <span> I/We hereby declare that information entered in this application is valid/correct and to the best of my/our knowledge.</span>:<span>نحن نقر/نعلن بموجب هذا أن المعلومات المدخلة في هذا الطلب صالحة/صحيحة على حد علمنا.</span> }<br /><br />
                    {/*                               
                              I/We agree to abide by the terms and conditions set out in the Policy. <br /><br />
                              I/We hereby declare that information entered in this application is valid/correct and to the best of my/our knowledge. */}
                  </p>

                </Col>

              </Row>


              <button type="submit" onClick={handleSubmit} className="btn btn-primary rounded-pill text-white my-3 py-1 px-4">{t('Submit')}</button>

              {/* </form> */}


            </Col>

            <Col md={3}></Col>

          </div>

        </div>
      </div>

      <Footer />

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

    </Fragment>
  );
}

export default Outboundquestion;